export default (theme) => ({
  appointmentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  controlButtonText: {
    marginLeft: 10,
    lineHeight: 1,
  },
  appointmentJoinButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 45,
    [theme.breakpoints.down('xl')]: {
      height: 40,
    },
    [theme.breakpoints.down('md')]: {
      height: 45,
    },
  },
  appointmentConfirmButton: {
    marginLeft: 10,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 45,
    [theme.breakpoints.down('xl')]: {
      height: 40,
    },
    [theme.breakpoints.down('md')]: {
      height: 45,
    },
  },
  appointmentConfirmedButton: {
    background: `${theme.palette.primary.main}30`,
    pointerEvents: 'none',
  },
  confirmButtonIcon: {
    minWidth: 23,
    minHeight: 23,
    width: 23,
    height: 23,
    fill: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      minWidth: 17,
      minHeight: 17,
      width: 17,
      height: 17,
    },
  },
  alert: {
    justifyContent: 'center',
  },
  appointmentLoadingWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 60,
  },
  appointmentInfoWrapper: {
    padding: '50px 75px 20px',
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      padding: '20px 28px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: 20,
    },
  },
  appointment: {
    overflow: 'auto',
    overflowX: 'hidden',
    width: '100%',
    height: '100%',
    flex: 1,
  },
  infoItem: {
    width: 'calc(100% / 2 - 20px)',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  joinButtonIcon: {
    minWidth: 23,
    minHeight: 23,
    width: 23,
    height: 23,
    fill: theme.palette.background.white,
    [theme.breakpoints.down('sm')]: {
      minWidth: 17,
      minHeight: 17,
      width: 17,
      height: 17,
    },
  },
});
